import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import Form from "../../../ui/Form";
import FileField from "../../../ui/FileField";
import RadioGroup from "../../../ui/RadioGroup";
import ModalScreenTitle from "../../../layout/admin/ModalScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import modalStyles from "../../../layout/admin/Modal.module.scss";
import { validateRequired } from "../../../../utils/validate";
import { postUploadStudent } from "../../../../services/apiStudent";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { MAX_UPLOAD_SIZE } from "../../../../utils/config";

const StudentUploadModal = (props) => {
  // アップロード完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // ローディング画像表示
  const [loading, setLoading] = useState(false);
  // 区分データ
  const [codeElement009, SetCodeElementStudentType] = useState([]);
  // ラジオボタン選択値
  const [selectedStudentType, setSelectedStudentType] = useState();

  const CLUB_STUDENT = 2;

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();

  // アップロード
  async function onSubmit(data) {
    setLoading(true);
    // アップロード処理
    const json = await postUploadStudent(data);
    if (json) {
      if (json.result) {
        // アップロード完了画面表示
        setCompFlg(true);
        // アップロード完了画面の「閉じる」で親画面を再レンダリングさせる為に一時的に親画面の再レンダリングをfalseに設定
        // useEffectが動作するが再レンダリングがfalseの場合は再レンダリングさせない
        props.setReloadFlag(false);
      } else {
        setLoading(false);
        setError("student", { message: json.msg });
      }
    }
  }

  const closeModal = () => {
    // モーダル閉じる
    props.setShowModal(false);
    if (compFlg) {
      // 親画面を再描画
      const nurl = new URL(window.location.href);
      window.location.href = nurl.origin + "/admin/student";
    } else {
      // 親画面の再レンダリングフラグをtrueに戻すことで親画面を再レンダリング
      props.setReloadFlag(true);
    }
  };

  useEffect(() => {
    (async function () {
      //区分値を設定
      const data = await getCodeMasterList({ code: "CD009" });
      SetCodeElementStudentType(
        // クラブ学生をデフォルトにする
        data.map((d) => {
          let defaultChecked = d.d_value === CLUB_STUDENT;
          if (defaultChecked) {
            setSelectedStudentType(d.d_value);
            setValue("student_type", d.d_value);
          }
          return {
            label: d.d_text,
            value: d.d_value,
            defaultChecked: defaultChecked,
          };
        })
      );
    })();
  }, []);

  const returnContents = (flg) => {
    if (flg) {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.lotterymodalContent}>
            <div className={modalStyles.lotteryModalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>学生情報アップロード完了</ModalScreenTitle>
            <Explanation>学生情報アップロードが完了しました。</Explanation>
            <div className={styles.buttonbox}>
              <a onClick={() => closeModal()}>
                <span className={styles.decoration}>閉じる</span>
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.uploadModalContent}>
            <div className={modalStyles.uploadModalButtonWrap}>
              <button
                disabled={loading}
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>学生情報アップロード</ModalScreenTitle>
            <Explanation>
              ファイルを選択し、アップロードボタンを押してください。 <br />
              ※既に登録されている学生は登録・更新されません。
            </Explanation>
            <div className="mt-5">
              <Form onSubmitHandler={handleSubmit(onSubmit)}>
                <FileField
                  name="student"
                  label="学生情報CSVファイル"
                  accept="text/csv"
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  errors={errors}
                  setValue={setValue}
                  setError={setError}
                  clearErrors={clearErrors}
                  required={true}
                  maxSize={MAX_UPLOAD_SIZE}
                />
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="学生区分"
                  name="student_type"
                  elements={codeElement009}
                  watch={watch}
                  selectedValue={selectedStudentType}
                  setSelectedValue={setSelectedStudentType}
                  isStatic={false}
                />
                <div className={styles.buttonbox}>
                  {loading ? (
                    <p>
                      <Explanation>
                        <img
                          id="ImageProgress"
                          className={styles.loadingGif}
                          src="/common/assets/images/processing.gif"
                        />
                        <span className="ps-3">登録中です・・・</span>
                      </Explanation>
                    </p>
                  ) : (
                    <Button type="submit" styleType="new">
                      アップロード
                    </Button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>
      );
    }
  };

  return <>{props.showFlag ? returnContents(compFlg) : <></>}</>;
};

export default StudentUploadModal;
